class LandingProductSection extends HTMLElement {
  constructor() {
    super()
    this.stepBlocks = this.querySelectorAll('[data-step]')
    this.productBlock = this.querySelector('.final-step__list')
    this.addButtons = this.querySelectorAll('.final-step__product__button')
    this.clickedBlock = null
    this.isProductVisible = false

    this.clearCart()

    this.stepBlocks.forEach(block => {
      block.addEventListener('click', () => {
        this.clickedBlock = block
        this.highlightBlock()      
      })
    })

    this.addButtons.forEach(button => {
      button.addEventListener('click', this.clearCartAndAddToCart.bind(this))
    })
  }

  clearCart() {
    return fetch('/cart/clear.js')
  }

  clearCartAndAddToCart(event) {
    event.preventDefault()
    event.stopPropagation()
    this.clearCart()
      .then(() => {
        this.addToCart()
      })
  }

  highlightBlock() {
    let currentStep = this.clickedBlock.dataset.step
    let prevActiveBlock = this.querySelector(`[data-step="${currentStep}"].step-block__item--active`)
    if (prevActiveBlock) {
      prevActiveBlock.classList.remove('step-block__item--active')
    }
    this.clickedBlock.classList.add('step-block__item--active')
    this.openNextStep()
  }

  openNextStep() {
    let nextStep = +this.clickedBlock.dataset.step + 1
    let nextStepWrapper = this.querySelector(`[data-step="${nextStep}"]`)
    if (this.isProductVisible) this.showProduct();
    if (nextStepWrapper) {
      nextStepWrapper.closest('.step-block').classList.add('step-block--active')
      if (!this.isProductVisible) {
        window.scrollTo({ top: nextStepWrapper.offsetTop - 100, behavior: 'smooth'});
      }
    } else {
      this.showProduct()
    }
  }

  showProduct() {
    this.isProductVisible = true
    this.productBlock.classList.add('active')
    let productIdToShow = this.querySelector('.step-block__item--active').dataset.product
    let productItem = this.querySelector(`[data-id="${productIdToShow}"]`)
    let prevProduct = this.querySelector('.final-step__product--active')
    if (prevProduct && prevProduct != productItem) {
      prevProduct.classList.remove('final-step__product--active')
    }
    productItem.classList.add('final-step__product--active')
    window.scrollTo({ top: this.productBlock.offsetTop - 100, behavior: 'smooth'});
  }

  addToCart() {
    let object = JSON.parse(this.querySelector('#landing-product__object').innerHTML).settings
    let activeProduct = this.querySelector('.final-step__product--active')
    let productId = activeProduct.dataset.id
    let selectedVarinat = this.querySelector('.step-block__item--active[data-variant]') ? this.querySelector('.step-block__item--active[data-variant]').dataset.variant : 'Default Title'
    let products = object.products
    let variantId
    let currentProduct
    let currentPrice = +activeProduct.querySelector('[data-current-price]')?.dataset.currentPrice?.replace('$','')
    let regularPrice = +activeProduct.querySelector('[data-regular-price]')?.dataset.regularPrice?.replace('$','')
    for (let product = 0; product < object.products.length; product++) {
      if (products[product].id == productId) {
        currentProduct = products[product]
        for (let i = 0; i < currentProduct.variants.length; i++) {
          if (currentProduct.variants[i].title == selectedVarinat) {
            variantId = currentProduct.variants[i].id
            break
          }
        }
      }
    }
    let atcObject = {
      'items': [{
        'id': Number(variantId),
        'quantity': Number(object.quantity)
      }]
    };
    if (object.subscription_name) {
      let subscriptionGroups = currentProduct.selling_plan_groups[0].selling_plans
      for (let i = 0; i < subscriptionGroups.length; i++) {
        if (subscriptionGroups[i].name == object.subscription_name ) {
          atcObject.items[0].selling_plan = subscriptionGroups[i].id
          break 
        }
      }
    }
    if (window.landing_uniq_prop != '') {
      atcObject.items[0].properties = {
        _landingSubscription: window.landing_uniq_prop
      }
    }
    if(localStorage.getItem('first-visited-page')){
      atcObject.items[0].properties = atcObject.items[0].properties || {};
      atcObject.items[0].properties['_first_visited_page'] = localStorage.getItem('first-visited-page');
    }

    window.klaviyoItem = {
      Name: currentProduct.title,
      ProductID: currentProduct.id,
      Categories: currentProduct.title,
      ImageURL: currentProduct.featured_image,
      URL: `${window.location.origin}/products/${currentProduct.handle}`,
      Brand: currentProduct.vendor,
      Price: window.theme.moneyFormat?.replace('{{amount}}', currentPrice.toFixed(2)),
      CompareAtPrice: window.theme.moneyFormat?.replace('{{amount}}', regularPrice.toFixed(2))
    }

    klaviyo.push(['track', 'Added to Cart', klaviyoItem]);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(atcObject)
    })
    .then(() => {
      window.location.href = object.discount_code ? `/checkout?discount=${object.discount_code}` : '/checkout'
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

}

customElements.define('landing-product', LandingProductSection);